import { ArrowLeft, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import SiteFooter from './SiteFooter';

export default function ContentPageLayout({
  eyebrow,
  title,
  intro,
  lastUpdated,
  companionLink,
  children,
}) {
  return (
    <div className="content-page">
      <header className="content-page__masthead">
        <div className="site-container content-page__topbar">
          <Link to="/" className="content-page__brand">
            <img
              src="/assets/icon.svg"
              alt=""
              aria-hidden="true"
              className="content-page__brand-mark"
            />
            <span className="content-page__brand-text">TECNIQ</span>
          </Link>

          <nav className="content-page__actions" aria-label="Page navigation">
            <Link to="/" className="tk-button tk-button--secondary tk-button--compact">
              <ArrowLeft size={16} />
              Back to home
            </Link>

            {companionLink ? (
              <Link to={companionLink.to} className="tk-button tk-button--tertiary tk-button--compact">
                {companionLink.label}
                <ArrowUpRight size={16} />
              </Link>
            ) : null}
          </nav>
        </div>
      </header>

      <main className="content-page__main">
        <section className="content-page__hero">
          <div className="site-container content-page__hero-grid">
            <div className="content-page__copy">
              {eyebrow ? <p className="spec-label">{eyebrow}</p> : null}
              <h1 className="content-page__title">{title}</h1>
              {intro ? <p className="content-page__intro">{intro}</p> : null}
            </div>

            <aside className="content-page__meta ghost-outline">
              <p className="spec-label">Last updated</p>
              <p className="content-page__meta-date">{lastUpdated}</p>
              <p className="content-page__meta-copy">
                Presented in the same editorial system as the TECNIQ landing experience while preserving the original policy language.
              </p>
            </aside>
          </div>
        </section>

        <article className="site-container legal-page__content">{children}</article>
      </main>

      <SiteFooter />
    </div>
  );
}
